import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('USERS_ONLINE').plugin(axiosPlugin, {template: "array"});

let fetchUsersOnlineAction = redux.fetchActionGetOne();

export const fetchUsersOnline = () => fetchUsersOnlineAction(`/users/online`);
export const resetUsersOnline = () => redux.actions.reset();

export const usersOnline = redux.reducer();